import React, { useEffect, useState } from "react";
import { Typography, Button, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";

const { Title } = Typography;

function Sprints() {

  const navigate = useNavigate();
  const { projectId } = useParams();

  const [project, setProject] = useState(null);
  const [sprints, setSprints] = useState([]);

  useEffect(() => {

    const token = localStorage.getItem("access-token");

    const fetchProject = async () => {

      try {

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/projects/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        setProject(data);

      } catch (error) {

        message.error("Failed to load project");

      }

    };

    const fetchSprints = async () => {

      try {

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/sprints/project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        if (Array.isArray(data)) {
          setSprints(data);
        } else {
          setSprints([]);
        }

      } catch (error) {

        message.error("Failed to load sprints");

      }

    };

    if (projectId) {
      fetchProject();
      fetchSprints();
    }

  }, [projectId]);

  return (
    <div>

      <Row justify="space-between" align="middle">
        <Title level={3}>
          Sprints {project ? `- ${project.projectName}` : ""}
        </Title>

        <div>

          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => navigate(`/admin/create-sprint/${projectId}`)}
          >
            Create Sprint
          </Button>

          <Button
            onClick={() => navigate(`/admin/manage-sprints/${projectId}`)}
          >
            Manage Sprints
          </Button>

        </div>
      </Row>

      <p style={{ marginTop: 20 }}>
        Total Sprints : <b>{sprints.length}</b>
      </p>

    </div>
  );
}

export default Sprints;